/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Input_Position_Dialog_ValidatorInputs */

const en_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please enter a number between 1 and ${i?.max}`)
};

const fr_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nombre entre 1 et ${i?.max}`)
};

const de_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine Zahl zwischen 1 und ${i?.max} ein.`)
};

const it_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inserisci un numero compreso tra 1 e ${i?.max}`)
};

const ru_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите число от 1 до ${i?.max}`)
};

const es_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un número entre 1 y ${i?.max}`)
};

const zh_cn2_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请输入 1 到 ${i?.max} 之间的数字`)
};

const ja_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1から${i?.max}までの数字を入力してください`)
};

const hi_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कृपया 1 और ${i?.max} के बीच एक संख्या दर्ज करें`)
};

const pt_pt2_input_position_dialog_validator = /** @type {(inputs: Input_Position_Dialog_ValidatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por favor, insira um número entre 1 e ${i?.max}`)
};

/**
* | output |
* | --- |
* | "Please enter a number between 1 and {max}" |
*
* @param {Input_Position_Dialog_ValidatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_dialog_validator = /** @type {((inputs: Input_Position_Dialog_ValidatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Dialog_ValidatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_dialog_validator(inputs)
	if (locale === "de") return de_input_position_dialog_validator(inputs)
	if (locale === "it") return it_input_position_dialog_validator(inputs)
	if (locale === "ru") return ru_input_position_dialog_validator(inputs)
	if (locale === "es") return es_input_position_dialog_validator(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_dialog_validator(inputs)
	if (locale === "ja") return ja_input_position_dialog_validator(inputs)
	if (locale === "hi") return hi_input_position_dialog_validator(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_dialog_validator(inputs)
	return en_input_position_dialog_validator(inputs)
});